import { getScoreColor, getTextColor } from '../../../utilities/common/color';
import GrowthStat from '../utils/GrowthStat';
import { WidgetDefinition } from '../../../shared/types/widget';

interface ScoreInfoCardProps {
  definition: WidgetDefinition;
  content: any;
}

function ScoreInfoCard({ definition, content }: ScoreInfoCardProps) {

  return (
    <div className="relative">
      <div className="relative flex divide-x overflow-auto p-6 md:gap-x-2 lg:gap-x-16">
        <div className="mb-3 flex gap-x-4 pr-4 font-medium lg:pr-0">
          <div className="flex flex-col items-center">
            <p className="text-black-500 text-sm">Overall score</p>
            <p
              className={`mt-6 leading-[60px] whitespace-nowrap md:text-[42px] lg:text-[64px] ${getTextColor(
                getScoreColor(content?.data?.value, content?.data?.benchmark),
              )}`}
            >
              {content?.data?.value}/ 100
            </p>
            {content?.data?.growth && (
              <GrowthStat score={+content?.data?.growth} />
            )}
          </div>
        </div>
        <div className="w-full px-4 pr-6 lg:px-16">
          <div className="intl-widget-ignore-element flex h-full w-full flex-col justify-center">
            <p className="text-black-900 text-lg font-semibold">
              {content?.data?.title}
            </p>
            <p className="text-black-600 text-sm">
              {content?.data?.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoreInfoCard;
